import { useCallback, useState } from 'react';

export const useDataRefresh = (): [
  refreshKey: number,
  requestRefresh: () => void,
] => {
  const [refreshKey, setRefreshKey] = useState(0);

  const requestRefresh = useCallback(() => {
    setRefreshKey((value) => value + 1);
  }, []);

  return [refreshKey, requestRefresh];
};
